module.exports = __webpack_public_path__ + "static/slider-perks-img2-97caf36ac67466c87119ffba34f1806f.jpeg";